import { render } from "./SpmTableAPI.vue?vue&type=template&id=79b363db"
import script from "./SpmTableAPI.vue?vue&type=script&lang=ts"
export * from "./SpmTableAPI.vue?vue&type=script&lang=ts"

import "./SpmTableAPI.vue?vue&type=style&index=0&id=79b363db&lang=scss"
import "./SpmTableAPI.vue?vue&type=style&index=1&id=79b363db&lang=scss"
script.render = render

export default script